export default __webpack_public_path__ + "assets/cd8d2a2a83d98524771e0155089f1fdc.woff";